export default {
  // Hero
  'hero.badge': '制造联盟',
  'hero.title': '大型工厂组成的制造联盟',
  'hero.imageAlt': '制造联盟工厂园区',
  'hero.subtitle':
    '四个专业且高度自动化的生产基地携手合作，直接为全球品牌供应化妆品包装。',
  'hero.message':
    '我们不是连接来路不明供应商的贸易公司，而是由真实、大型、高度自动化的工厂共同组建的制造联盟（Manufacturing Alliance）。我们整合四大专业生产基地的能力，为您提供可靠的品质、稳定的量产、一体化供应以及极具竞争力的全球价格。',
  'hero.cta.quote': '申请报价',
  'hero.cta.contact': '联系我们的团队',
  'hero.scroll': '浏览我们的工厂',

  // Intro
  'intro.label': '我们的供应商网络',
  'intro.title': '重新定义供应商网络',
  'intro.subtitle': '制造联盟如何将专业工厂整合为一条一体化的供应链。',
  'intro.networkTitle': '专业工厂的统一联盟',
  'intro.networkDesc':
    '与零散、未经核实的供应商采购不同，我们的制造联盟将四个专业生产基地整合到同一个协同运营体系之下。每家工厂专注各自的强项——玻璃、软管、塑料与整装包装——同时共享统一的品质、自动化与可靠性标准。',
  'intro.stat.factories': '4',
  'intro.stat.factories.label': '专业工厂',
  'intro.stat.automation': '第4代',
  'intro.stat.automation.label': '自动化生产',
  'intro.stat.integrated': '1',
  'intro.stat.integrated.label': '一体化供应链',

  // Factories
  'factories.label': '我们的设施',
  'factories.title': '认识四大工厂',
  'factories.subtitle': '每一处设施都是拥有第4代自动化设备与专属质量管理的真实大型生产基地。',

  // Factory common labels
  'factory.label': '工厂',
  'factory.introduction': '工厂介绍',
  'factory.products': '主要产品',
  'factory.technology': '专业生产技术',
  'factory.automation': '自动化与产能',
  'factory.capacity': '年产能',
  'factory.established': '成立年份',
  'factory.qc': '质量管理',

  // Gallery labels
  'gallery.title': '图集',
  'gallery.scrollLeft': '向左滚动',
  'gallery.scrollRight': '向右滚动',
  'gallery.overview': '工厂全景',
  'gallery.productionLine': '生产线',
  'gallery.automation': '自动化设备',
  'gallery.qc': '质量管理',
  'gallery.warehouse': '仓库',
  'gallery.rawMaterial': '原材料',
  'gallery.finished': '成品',
  'gallery.printing': '印刷',
  'gallery.molding': '注塑成型',
  'gallery.assembly': '组装',
  'gallery.decoration': '表面装饰',

  // Placeholders
  'placeholder.tbd': '[待定]',
  'placeholder.pending': '信息待补充',

  // Glass Bottles Factory
  'factory.glass.name': 'Cristallo Glassworks Co., Ltd.',
  'factory.glass.tagline': '高端玻璃容器专家',
  'factory.glass.history':
    '2003年，Cristallo Glassworks 从广州一个单炉作坊起步，现已成长为占地180,000平方米的出口型生产基地。目前运营12条自动化玻璃成型与退火生产线，为欧洲、北美和日本的40多个化妆品品牌供货。',
  'factory.glass.established': '2003年',
  'factory.glass.capacity': '年产1.2亿件',
  'factory.glass.product1': '化妆品玻璃瓶',
  'factory.glass.product2': '玻璃滴管瓶',
  'factory.glass.product3': '玻璃面霜罐',
  'factory.glass.product4': '香水玻璃瓶',
  'factory.glass.spec1': '精密玻璃成型',
  'factory.glass.spec2': '彩色喷涂与磨砂',
  'factory.glass.spec3': '丝网印刷与烫金',
  'factory.glass.spec4': '高透明玻璃成型',
  'factory.glass.automation':
    '配备第4代自动化玻璃成型、退火与检测生产线，实现大批量、稳定的生产。',
  'factory.glass.qc':
    '覆盖尺寸精度、透明度、耐压性与表面光洁度的多阶段检测，并实现全程可追溯。',

  // Cosmetic Tubes Factory
  'factory.tubes.name': 'FlexoTech Tube Industries',
  'factory.tubes.tagline': '复合与挤压软管专家',
  'factory.tubes.history':
    '成立于1998年的 FlexoTech 率先在该地区推行 ABL 软管复合技术。拥有三处生产基地和28条挤出、印刷与灌装生产线，每年向全球美妆与个人护理品牌供应超过3亿支软管。',
  'factory.tubes.established': '1998年',
  'factory.tubes.capacity': '年产3亿件',
  'factory.tubes.product1': '化妆品复合软管',
  'factory.tubes.product2': '塑料挤压软管',
  'factory.tubes.product3': 'ABL / PBL 软管',
  'factory.tubes.product4': '真空（无空气）软管',
  'factory.tubes.spec1': '软管挤出与复合',
  'factory.tubes.spec2': '软管灌装与封口',
  'factory.tubes.spec3': '多色胶版印刷',
  'factory.tubes.spec4': '软管肩部与盖子成型',
  'factory.tubes.automation':
    '高速自动化挤出、多色印刷、灌装与封口生产线，确保稳定的批量生产。',
  'factory.tubes.qc':
    '依据标准化 QC 流程，对印刷质量、密封完整性与材料一致性进行检测。',

  // Plastic Bottles Factory
  'factory.plastic.name': 'PolyForm Packaging Co., Ltd.',
  'factory.plastic.tagline': 'PET / PP 瓶专家',
  'factory.plastic.history':
    '成立于2006年的 PolyForm 专注于 PET、PP 和 PETG 瓶。其全自动化吹塑工厂全天候运转，并配备机器人分拣与检测系统，每年向30多个国家的客户交付5亿个瓶子。',
  'factory.plastic.established': '2006年',
  'factory.plastic.capacity': '年产5亿件',
  'factory.plastic.product1': 'PET 化妆品瓶',
  'factory.plastic.product2': 'PP / PETG 瓶',
  'factory.plastic.product3': '真空泵头瓶',
  'factory.plastic.product4': '乳液与喷雾瓶',
  'factory.plastic.spec1': '注射拉伸吹塑',
  'factory.plastic.spec2': '挤出吹塑',
  'factory.plastic.spec3': '注塑成型',
  'factory.plastic.spec4': '表面装饰与涂层',
  'factory.plastic.automation':
    '全自动化吹塑与机器人分拣系统，提供高速、精密的批量生产。',
  'factory.plastic.qc':
    '对每一生产批次进行尺寸、跌落与渗漏测试，确保产品可靠、零缺陷。',

  // Cosmetic Packaging Manufacturer
  'factory.packaging.name': 'CosmePack Manufacturing Group',
  'factory.packaging.tagline': '一体化包装解决方案',
  'factory.packaging.history':
    '自1995年起，CosmePack 将装饰、组装与交钥匙包装整合为单一流程。作为我们联盟的旗舰设施，它负责从原材料采购到可上市成品包装的完整 OEM/ODM 项目。',
  'factory.packaging.established': '1995年',
  'factory.packaging.capacity': '交钥匙一体化供应',
  'factory.packaging.product1': '整套化妆品包装',
  'factory.packaging.product2': '瓶盖、泵头与配件',
  'factory.packaging.product3': '粉饼与气垫外壳',
  'factory.packaging.product4': '定制 OEM 包装',
  'factory.packaging.spec1': '整装包装组装',
  'factory.packaging.spec2': '多工序装饰',
  'factory.packaging.spec3': 'OEM / ODM 解决方案',
  'factory.packaging.spec4': '交钥匙包装供应',
  'factory.packaging.automation':
    '配备机器人搬运的一体化自动组装与装饰生产线，可灵活实现大批量包装生产。',
  'factory.packaging.qc':
    '从原材料进厂到成品出货的端到端质量管理，涵盖颜色匹配与功能测试。',

  // Integrated supply
  'integrated.label': '我们交付价值的理由',
  'integrated.title': '一体化供应，无可比拟的价值',
  'integrated.subtitle':
    '通过将四家专业工厂整合为单一联盟，我们提供分散采购无法实现的成果。',
  'integrated.quality.title': '可靠的品质',
  'integrated.quality.desc':
    '四大设施统一的标准化质量管理，确保每一笔订单都稳定、可靠。',
  'integrated.stability.title': '稳定的量产能力',
  'integrated.stability.desc':
    '第4代自动化生产线，提供大批量订单所需的产量与一致性。',
  'integrated.supply.title': '一体化供应',
  'integrated.supply.desc': '通过单一协同联盟，一站式采购玻璃、软管与塑料包装。',
  'integrated.price.title': '具有竞争力的全球价格',
  'integrated.price.desc':
    '工厂直采、无中间环节，让成本透明且在全球范围内保持竞争力。',

  // Quality control
  'qc.label': '品质保证',
  'qc.title': '质量管理与检验',
  'qc.subtitle': '每一家工厂都遵循同样严格、多阶段的品质保证流程。',
  'qc.item1': '来料检验',
  'qc.item2': '制程中的尺寸与外观检查',
  'qc.item3': '耐压与渗漏测试',
  'qc.item4': '印刷与颜色匹配核验',
  'qc.item5': '功能与组装测试',
  'qc.item6': '出货前最终检验',

  // CTA
  'cta.label': '开始采购',
  'cta.title': '准备好安心采购了吗？',
  'cta.subtitle': '告诉我们您的包装需求，即可从我们的制造联盟直接获取报价。',
  'cta.quote': '申请报价',
  'cta.contact': '联系我们的团队',
};